import MdaeTooltip from "./component";
import { ITooltipOptions } from "devextreme-react/tooltip";
import { IMdaeDataUpdaterConfig } from "../../mdae-framework";
export interface IMdaeTooltipProps extends ITooltipOptions {
  id: string;
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}
export default MdaeTooltip;
